
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesCoaches = Marionette.ItemView.extend({
		template: null,
		ui: {
			'remove_user': '',
			'remove_team': '',
			'show_more':   ''
		},
		events: {
			'click @ui.remove_user': 'removeUser',
			'click @ui.remove_team': 'removeTeam',
			'click @ui.show_more':   'loadMore'
		},
		initialize: function() {
			this.scrollToTop();
			this.league_id = this.getOption('league_id');
			this.league    = this.getOption('league');
			this.coaches   = this.getOption('coaches');
			this.user      = this.getOption('user');
			this.offset    = 0;
			this.limit     = 20;

			this.model.set({
				league: {},
				coaches: []
			});

			this.initListners();

			var complete = [
				this.league.show().fetch({ data: { id: this.league_id } }),
				this.coaches.show().fetch({ data: { league_id: this.league_id, offset: this.offset, limit: this.limit } })
			];

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));
		},
		initTemplate: function() {
			if (this.initData().isCanAccess()) {
				console.log(111);
				this.trigger('leagues:manage:menu', this.league);
				return this.setModelData().render();
			}

			return this;
		},
		initData: function() {
			this.league.setCommissioner(this.user.get('id'));

			return this;
		},
		initListners: function () {
			this.listenTo(this.league, 'leagues:errors', this.showErrors);
			this.listenTo(this.league, 'leagues:remove_coach:success', this.coachRemoved);
			this.listenTo(APP.vent, 'leagues_manage_controls:change_league', this.changeLeague);

			return this;
		},
		isCanAccess: function() {
			if (!this.league.get('id')) {
				this.trigger('leagues:http_status:404');

				return false;
			}
			else if (!this.league.get('is_commissioner')) {
				this.trigger('leagues:http_status:403');

				return false;
			}

			return true;
		},
		setModelData: function() {
			this.model.set({
				league:      this.league.toJSON(),
				coaches:     this.coaches.toJSON(),
				avatars_url: CONFIG.AVATARS_URL
			});

			return this;
		},
		removeUser: function(e) {
			var user = this.coaches.findWhere({ id: +$(e.currentTarget).data('id') });

			if (confirm('Are you sure you want to remove ' + user.get('first_name') + ' ' + user.get('last_name') + ' from the league?')) {
				this.showPreloader();
				this.league.remove_user(user.get('id'));
			}

			return this;
		},
		removeTeam: function(e) {
			var team = this.coaches.findWhere({ id: +$(e.currentTarget).data('id') });

			if (confirm('Are you sure you want to remove ' + team.get('name') + ' from the league?')) {
				this.showPreloader();
				this.league.remove_team(team.get('id'));
			}

			return this;
		},
		coachRemoved: function(id) {
			this.hidePreloader();
			this.coaches.remove(this.coaches.findWhere({ id: id }) || this.coaches.findWhere({ user_id: id }));
			this.league.set('num_teams', this.league.get('num_teams')-1);

			return this.setModelData().render();
		},
		changeLeague: function(league_id) {
			this.league_id = league_id;

			var complete = [
				this.league.show().fetch({ data: { id: this.league_id } }),
				this.coaches.show().fetch({ data: { league_id: this.league_id, offset: this.offset, limit: this.limit } })
			];

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));
		},
		loadMore: function() {
			this.showPreloader();
			this.offset += this.limit;

			var complete = [
				this.coaches.show().fetch({ remove: false, data: { league_id: this.league_id, offset: this.offset, limit: this.limit }})
			];

			$.when.apply(null, complete).done(_.bind(function() {
				return this.hidePreloader().setModelData().render();
			}, this));
		}
	});

}(window, APP, Backbone, Marionette, $, _));
